export enum ClientEventStatuses {
  /**
   * Новое
   */
  NEW = 'New',

  /**
   * Просмотрено
   */
  VIEW = 'View',

  /**
   * В работе
   */
  IN_WORK = 'In_work',

  /**
   * Выполнено
   */
  DONE = 'Done',

  /**
   * Отменено
   */
  CANCEL = 'Cancel',
}
